import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import fetchData from '../../main/reports/hoc/fetchData';
import BarberReport from '../../main/reports/barberReport';
import {
  getBarberUserReports,
  getBarberReportsCsv,
} from '../../main/reports/actions';
import { getActiveCategoryIds } from '../../main/reports/selectors';
import withTimezone from '../../auth/utils/withTimezone';
import { activeShopName } from '../../auth/selectors';

const mapStateToProps = state => ({
  barberUser: state.auth.barberUser,
  serviceCategories: getActiveCategoryIds(state),
  shopName: activeShopName(state),
});

const mapDispatchToProps = {
  getBarberUserReports,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTimezone,
  withHandlers({
    getReport: props => (start, end) => props.getBarberUserReports(
      props.barberUser.id,
      props.barberUser.shopId,
      start,
      end,
      props.serviceCategories
    ),
    getCsv: props => (start, end) =>
      getBarberReportsCsv({
        shopId: props.barberUser.shopId,
        shopName: props.shopName,
        barberId: props.barberUser.id,
        fromDate: start,
        toDate: end,
        timezone: props.timezone,
      }),
  }),
  fetchData
);

export default enhance(BarberReport);

